<template>
    <section id="planDetailsDiv">
        <div class="container mt-8">
            <div class="card shadow-lg border-0 rounded-4">
                <!-- Plan Title and Price Section -->
                <div class="row align-items-center">
                    <div class="col-md-8">
                        <h2 class="text-center mb-3 text-theme">{{ this.$route.query.name }}</h2>
                        <p class="fs-5 text-muted text-center mb-4">Perfect plan for your business needs</p>
                        <p class="fs-4 text-center text-success text-primary">
                            <strong>Price: ${{ this.$route.query.price }}</strong>
                        </p>
                    </div>
                    <div class="col-md-4">
                        <img src="https://api-blog.antiquitysl.com/wp-content/uploads/2019/07/Antiquity-Web-Articles-Image-June.png"
                            alt="Plan Image" class="">
                    </div>
                </div>

                <!-- Plan Features Section -->
                <div class="mt-4">
                    <h5 class="text-secondary mb-4">What's Included</h5>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">
                            <i class="bi bi-check-circle-fill text-success me-2"></i> Unlimited Access to Premium
                            Features
                        </li>
                        <li class="list-group-item">
                            <i class="bi bi-check-circle-fill text-success me-2"></i> 24/7 Customer Support
                        </li>
                        <li class="list-group-item">
                            <i class="bi bi-check-circle-fill text-success me-2"></i> Access to VIP Webinars and
                            Workshops
                        </li>
                        <li class="list-group-item">
                            <i class="bi bi-check-circle-fill text-success me-2"></i> Monthly SEO Optimization
                        </li>
                        <li class="list-group-item">
                            <i class="bi bi-check-circle-fill text-success me-2"></i> Exclusive Content and Resources
                        </li>
                        <li class="list-group-item">
                            <i class="bi bi-check-circle-fill text-success me-2"></i> Personalized Dashboard for
                            Monitoring Performance
                        </li>
                        <li class="list-group-item">
                            <i class="bi bi-check-circle-fill text-success me-2"></i> Priority Customer Service
                        </li>
                    </ul>
                </div>

                <!-- Purchase Section -->
                <div class="mt-5 d-flex justify-content-center gap-3">
                    <button id="purchaseButton" class="btn btn-success btn-md w-100 px-4 py-3 mb-3">Subscribe
                        Now</button>
                    <button class="btn btn-secondary btn-md w-20 px-4 py-3 mb-3 text-white"
                        @click="$router.push('/package-list')">Go Back</button>
                </div>


                <!-- Testimonials Section -->
                <!-- <div class="mt-5">
                    <h5 class="text-center text-primary mb-4">What Our Clients Say</h5>
                    <div v-if="testimonials.length > 0">
                        <div v-for="(testimonial, index) in testimonials" :key="index"
                            class="card shadow-sm mb-4 border-0 rounded-3">
                            <div class="card-body">
                                <p class="card-text">{{ testimonial.feedback }}</p>
                                <footer class="blockquote-footer text-muted">{{ testimonial.clientName }}</footer>
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-center">
                        <p class="fs-4 text-muted">No testimonials available for this plan.</p>
                    </div>
                </div> -->

            </div>
        </div>
    </section>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js';
import $ from 'jquery';
import Swal from 'sweetalert2';

export default {
    name: 'PlanDetails',
    data() {
        return {
            testimonials: [
                { clientName: 'John Doe', feedback: 'This plan helped us grow our business exponentially!' },
                { clientName: 'Jane Smith', feedback: 'Excellent features and customer support!' },
                { clientName: 'Mark Wilson', feedback: 'Highly recommend this plan!' }
            ]
        };
    },
    mounted() {
        // Initialize Stripe
        const stripe = Stripe(process.env.VUE_Stripe_Key); // Your Stripe public key

        // Handle Purchase Now button click
        $('#purchaseButton').on('click', () => {
            const price = 'price_1QMhaKAi5AUevdYRJ8ZTBDO3';
            const name = this.$route.query.name;

            var user = JSON.parse(localStorage.getItem('user'));
            var userId = user?.id;

            const successUrl = process.env.Vue_APP_URL +'/pay-success'; // Vue success URL
            const cancelUrl = process.env.Vue_APP_URL +'/pay-fail'; // Vue failure URL

            // Make an AJAX request to your backend to create a Checkout session
            $.ajax({
               url: process.env.VUE_APP_API_URL +'/create-checkout-session',
                method: 'POST',
                data: {
                    id : userId,
                    price_id: price,
                    name: name,
                    success_url: successUrl, // Pass the success URL
                    cancel_url: cancelUrl,   // Pass the failure URL
                },
                success: (response) => {
                    // Redirect to Stripe Checkout
                    stripe.redirectToCheckout({ sessionId: response.sessionId }).then((result) => {
                        if (result.error) {
                            Swal.fire({
                                title: 'Payment Failed',
                                text: result.error.message,
                                icon: 'error',
                                confirmButtonText: 'Retry',
                            }).then(() => {
                                this.$router.push('/payment-failure'); // Navigate to the failure page
                            });
                        }
                    });
                },
                error: (error) => {
                    console.error('Error creating checkout session:', error);
                    Swal.fire({
                        title: 'Error',
                        text: 'An error occurred while processing your payment.',
                        icon: 'error',
                        confirmButtonText: 'OK',
                    });
                }
            });
        });
    },
    methods: {

    }
}
</script>

<style scoped>
.text-theme {
    color: #37a2d3;
}

.text-primary {
    color: #bd0606 !important;
}

#planDetailsDiv {
    background-color: #f8f9fa;
    padding-top: 60px;
}

.card {
    border-radius: 20px;
    background-color: #ffffff;
    padding: 2rem;
}

.card img {
    max-width: 100%;
    border-radius: 15px;
}

h2 {
    font-size: 2.5rem;
    font-weight: 700;
}

ul.list-group {
    padding-left: 20px;
}

ul.list-group-item {
    background-color: #f8f9fa;
    border: none;
    font-size: 1.1rem;
}

ul.list-group-item i {
    font-size: 20px;
}

button {
    padding: 12px 30px;
    font-size: 18px;
    border-radius: 8px;
}

button.btn-primary {
    background-color: #007bff;
    border-color: #007bff;
}

button.btn-secondary {
    color: #6c757d;
    border-color: #6c757d;
}

button.btn-secondary:hover {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

button.btn-success {
    background-color: #28a745;
    border-color: #28a745;
}

button.btn-success:hover {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

blockquote-footer {
    font-size: 1rem;
    color: #6c757d;
}

.text-muted {
    color: #6c757d;
}

.card-body {
    padding: 1.5rem;
}

.card-text {
    font-size: 1.1rem;
    color: #333;
}

.card-footer {
    background-color: #f8f9fa;
}
</style>
